(function() {
  // CSS injection
  var style = document.createElement('style');
  style.id = 'weareone-custom-styles';
  style.textContent = [
    '.skip-to-content-link { display: none !important; visibility: hidden !important; position: absolute !important; left: -99999px !important; }',
    '.header-logo__image { --header-logo-image-height: 150px !important; --header-logo-image-height-mobile: 120px !important; max-height: 150px !important; }',
    '.menu-list__link { font-weight: 700 !important; }',
    '.menu-list__list-item:hover > .menu-list__submenu { visibility: visible !important; opacity: 1 !important; pointer-events: auto !important; }',
    '.menu-list__submenu { padding-top: 8px !important; margin-top: -8px !important; }'
  ].join(' ');
  document.head.appendChild(style);

  // Dropdown fix
  function fixDropdown() {
    var headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;
    var items = headerMenu.querySelectorAll('.menu-list__list-item');
    items.forEach(function(item) {
      var submenu = item.querySelector('.menu-list__submenu');
      if (!submenu) return;
      var link = item.querySelector('.menu-list__link');
      item.addEventListener('mouseenter', function() {
        if (link) link.setAttribute('aria-expanded', 'true');
        headerMenu.setAttribute('aria-expanded', 'true');
        headerMenu.style.setProperty('--submenu-opacity', '1');
        var hc = headerMenu.closest('header-component');
        if (hc) hc.style.setProperty('--submenu-height', submenu.scrollHeight + 'px');
      });
      item.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (!item.matches(':hover') && !submenu.matches(':hover')) {
            if (link) link.setAttribute('aria-expanded', 'false');
            headerMenu.setAttribute('aria-expanded', 'false');
            headerMenu.style.setProperty('--submenu-opacity', '0');
            var hc = headerMenu.closest('header-component');
            if (hc) hc.style.setProperty('--submenu-height', '0px');
          }
        }, 200);
      });
      submenu.addEventListener('mouseenter', function() {
        if (link) link.setAttribute('aria-expanded', 'true');
        headerMenu.setAttribute('aria-expanded', 'true');
        headerMenu.style.setProperty('--submenu-opacity', '1');
      });
      submenu.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (!item.matches(':hover') && !submenu.matches(':hover')) {
            if (link) link.setAttribute('aria-expanded', 'false');
            headerMenu.setAttribute('aria-expanded', 'false');
            headerMenu.style.setProperty('--submenu-opacity', '0');
            var hc = headerMenu.closest('header-component');
            if (hc) hc.style.setProperty('--submenu-height', '0px');
          }
        }, 200);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(fixDropdown, 2000); });
  } else {
    setTimeout(fixDropdown, 2000);
  }
})();